import { render, staticRenderFns } from "./foodrecipesdetails.vue?vue&type=template&id=ffcc0716&scoped=true"
import script from "./foodrecipesdetails.vue?vue&type=script&lang=js"
export * from "./foodrecipesdetails.vue?vue&type=script&lang=js"
import style0 from "./foodrecipesdetails.vue?vue&type=style&index=0&id=ffcc0716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcc0716",
  null
  
)

export default component.exports